import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';

export interface Location {
  countyFips: string;
  countyName: string;
  state: string;
  zipcode: string;
}

export const initialState: Location = {} as Location;

const locationSlice = createSlice({
  initialState,
  name: 'location',
  reducers: {
    setLocation: (_state, action: PayloadAction<Location>) => {
      return action.payload;
    },
  },
});

const { actions, reducer } = locationSlice;

export const { setLocation } = actions;

export const selectCurrentLocation = (state: RootState) => state.location;
export const selectZipCode = (state: RootState) => state.location.zipcode;

export default reducer;
